import pallet from '../constants/colors';

export default {
  icon: {
    marginRight: 8,
    color: pallet.appBarTextColor,
  },
  iconActivity: {
    marginLeft: 8,
    color: pallet.appBarTextColor,
  },
  checkboxRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: 8,
  },
  container: {
    margin: 16,
  },

  embedContainer: {
    padding: 24,
    width: '100%',
  },
  card: {
    maxWidth: 380,
    minWidth: 300,
    borderRadius: 8,
    height: 460,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: 24,
    paddingBottom: 24,
    backgroundColor: 'white',

  },
  embedCard: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 400,
    backgroundColor: 'white',
  },
  htmlContainer: {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: 8,
  },
  button: {
    marginTop: 'auto',
    alignSelf: 'flex-end',
  },
  dateRange: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  divider: {
    marginTop: 16,
    marginBottom: 16,
  },
  details: {
    marginTop: 12,
  },
  detailItem: {
    color: pallet.appBarTextColor,
  },
  detailItemValue: {
    color: pallet.titleColor,
    marginLeft: 8,
  },
  message: {
    height: 'auto',
    marginTop: 'auto',
  },
};



// WEBPACK FOOTER //
// ./src/styles/TransportationGrant.js